import styled from 'styled-components'

export const Container = styled.div`
  padding: 0 14px;

  > button {
    width: 100%;
    margin-top: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .customSpinner {
    width: 30px;
    height: 30px;
    border: 4px solid;
    border-top-color: transparent;
  }

  .errorMessageWrapper {
    max-width: 100%;

    > p {
      color: #fff;
    }
  }
`

export const TextWrapper = styled.div`
  margin: 10px 0 20px;
  > p {
    > span {
      font-weight: 600;
      color: #FF3D3D;
    }
  }
`

export const CalendarWrapper = styled.div`
  display: flex;
  justify-content: center;
`

export const SelectedNewDateContainer = styled.div`
  display: flex;
  flex-direction: column;

  > p {
    margin-top: 20px;
    color: #898989;
  }
`

export const SelectDateWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  padding: 0 10px;
  margin-top: 20px;
  
  > svg {
    cursor: pointer;
  }

  > div {
    width: 185px;
    > div {
      margin-top: 0 !important;
    }
  }
`